<script setup>
  import { computed } from 'vue';
  import Icon from '@/components/icons/Icon.vue';

  const props = defineProps({
    marker: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    units: {
      type: String,
      default: 'mi'
    },
    type: {
      type: String,
      default: 'distance'
    },
  });

  const displayValue = computed(() => {
    if (props.type === 'heading') {
      return `${props.marker.heading}°`;
    }

    return props.marker.prefix 
      ? `${props.marker.prefix}: ${props.marker.distance}${props.units}` 
      : `${props.marker.distance}${props.units}`;
  });
</script>

<template>
  <div
    :key="props.marker.id"
    :data-index="props.index"
    class="jwx-map-drawing__distance-marker"
    :style="`left: ${props.marker.midPoint.x}px; top: ${props.marker.midPoint.y}px;`"
  >
    {{ displayValue }}
    <Icon 
      v-if="props.type === 'heading'"
      name="arrow-up-alt-solid" 
      class="jwx-map-drawing__heading-marker-icon" 
      :style="`--heading-marker-icon-rotation: ${Number(props.marker.heading)}deg`" 
    />
  </div>
</template>